const pre = '/agent/';

export default {
    path: '/agent',
    title: '经纪人管理',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-dashboard',
    children: [
        {
            path: `${pre}agent`,
            title: '经纪人管理'
        }
    ]
}
